import { Component, HostListener, Input, OnInit } from "@angular/core";
import { Observable, of } from "rxjs";
import { CameraComponent } from "src/app/annotation/camera/camera.component";
import { PictureData } from "src/app/annotation/canvas/canvas.component";
import { Address } from "src/app/shared/Models/Address";
import { SurveyPhotoTypeEnum } from "src/app/shared/Models/enums/SurveyPhotoTypeEnum";
import { PhotoIndexInfo } from "src/app/shared/Models/interfaces/PhotoIndexInfo.interface";
import { ChangeOutsideSurveyPhotoRemarksDto } from "src/app/shared/Models/write/ChangeOutsideSurveyPhotoRemarksDto";
import { FacadeDetailPhotoRemarksDto } from "src/app/shared/Models/write/facadeDetailPhotoRemarks.model";
import { ToastService } from "src/app/shared/toast.service";
import { PhotoViewmodel } from "../../../shared/components/photo-and-remark/photo-viewmodel";
import { DeviceCheckService } from "../../../shared/services/device-check.service";
import { SurveyType } from "../../../shared/services/photo.service";
import { SavingStateService } from "../../../shared/services/saving-state.service";
import { OUTSIDE_SURVEY_PHOTOS } from "../../config/outside-survey.magic-strings";
import { FormValidationService } from "../../../shared/services/formValidation.service";
import { BuildingTypeEnum } from "src/app/shared/Models/enums/BuildingTypeEnum";

@Component({
  selector: "app-outside-survey-photo-form",
  templateUrl: "./outside-survey-photo-form.component.html",
  styleUrls: ["./outside-survey-photo-form.component.scss"],
  providers: [ToastService],
})
export class OutsideSurveyPhotoFormComponent implements OnInit {
  @Input() cameraLayer: HTMLDivElement;
  @Input() camera: CameraComponent;
  @Input() isAuthCanWrite: boolean;
  @Input() survey;
  @Input() address: Address;
  @Input() index: number;
  BuildingTypeEnum = BuildingTypeEnum;
  surveyType = SurveyType;
  surveyPhotoType = SurveyPhotoTypeEnum;

  viewmodel: PhotoViewmodel = {
    facadePhotos: [],
    detailPhotos: [],
    detailComment: [],
  };

  savedPhotoOrder: {
    detailPhotos: PhotoIndexInfo[];
  } = {
    detailPhotos: [],
  };
  unsavedPhotoOrder: {
    detailPhotos: PhotoIndexInfo[];
  } = {
    detailPhotos: [],
  };
  inPortrait: boolean;

  gotPhotoCallback: (data: PictureData) => void;

  constructor(
    private _savingStateService: SavingStateService,
    private _deviceCheckService: DeviceCheckService,
    private formValidationService: FormValidationService
  ) {}

  ngOnInit() {
    this.inPortrait = this._deviceCheckService.onPortrait();
    this.viewmodel = {
      facadePhotos: [
        ...this.survey.photos.facadePhotos.filter(
          (f) => f.data.addressId === this.address.id
        ),
      ],
      detailPhotos: [
        ...this.survey.photos.detailPhotos.filter(
          (f) => f.data.addressId === this.address.id
        ),
      ],
      detailComment: [],
    };
  }

  getErrors(address?: string, subTitle?: string, field?: string) {
    return this.formValidationService.getErrors(
      ...[OUTSIDE_SURVEY_PHOTOS, address, subTitle, field].filter((x) => !!x)
    );
  }

  @HostListener("window:resize")
  onResize() {
    this.inPortrait = this._deviceCheckService.onPortrait();
  }

  toggleLayer(layer: HTMLDivElement) {
    layer.classList.toggle("hidden");
  }

  save(): Observable<any> {
    if (
      !this.viewmodel.facadePhotos.some((e) => e.remarkChanged) &&
      !this.viewmodel.detailPhotos.some((e) => e.remarkChanged)
    )
      return of(true);

    var photoComments = this.viewmodel.facadePhotos
      .filter((e) => e.remarkChanged)
      .map((photo) => {
        photo.remarkChanged = false;
        return new FacadeDetailPhotoRemarksDto(
          photo.data.id,
          photo.facadeDetailPhotoRemark
        );
      });

    photoComments = photoComments.concat(
      this.viewmodel.detailPhotos
        .filter((e) => e.remarkChanged)
        .map((photo) => {
          photo.remarkChanged = false;
          return new FacadeDetailPhotoRemarksDto(
            photo.data.id,
            photo.facadeDetailPhotoRemark
          );
        })
    );

    const dto = new ChangeOutsideSurveyPhotoRemarksDto(
      this.survey.id,
      null,
      photoComments
    );

    return this._savingStateService.addOutsideSurveyMainPhoto(dto);
  }
}
